<template>
  <div class="tile" :class="{ 'tile-empty': tileRef === null }">
    <div class="tile-img"
         :style="tileStyle"
         ref="tileImg">
      <div v-if="label" class="tile-label">
        <span class="rounded tile-label-text" :style="labelStyle">{{label}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import designService from '../services/design.service';

export default {
    name: 'Tile',
    props: {
      tileRef: {
        type: Number,
        default: null,
      },
      plain: {
        type: Boolean,
        default: false,
      },
      highlighted: {
        type: Boolean,
        default: false,
      },
      label: {
        default: "",
      }
    },
    data() {
      return {
        labelStyle: {},
      }
    },
    mounted() {
      const size = Math.min(this.$refs.tileImg.clientWidth, this.$refs.tileImg.clientHeight);
      this.labelStyle = {
        fontSize: `${size / 4}px`
      };
    },
    computed: {
      tileImage() {
        return designService.getTileImage(this.tileRef);
      },
      tileStyle() {
        const design = designService.getCurrentDesign();
        let style = {
          width: `${design.tileWidth}px`,
          height: `${design.tileHeight}px`,
        };
        if (this.tileRef !== null) {
          if (this.highlighted) {
            style = {
              background: 'chartreuse', 
              maskImage: `url(${this.tileImage.plain.url})`,
              ...style,
            }
          } else {
            return {
              backgroundImage: `url(${this.plain ? this.tileImage.plain.url : this.tileImage.img.url})`,
              ...style,
            }
          }
        }
        return style;
      }
    },
}
</script>
<style>
.tile .tile-img {
  width: 100%;
  display: block;
  position: relative;
  mask-size: contain;
  background: none transparent no-repeat left top;
  background-size: contain;
}
.tile div.tile-img {
  height: 100%;
}
.tile .tile-img .tile-label {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translate(0,-50%);
}

.tile .tile-img .tile-label span {
  font-weight: bold;
  background: rgba(255, 255, 255, 0.6);
}
.tile.tile-empty {
  border: 1px dashed #999;
}
.tile-label-text {
  padding: 2px;
}
</style>